import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';
"use strict";
const MicrositeProductPageContext = createContext(null);
const MicrositeProductPageContextProvider = ({
  showBuyButton,
  children
}) => {
  return /* @__PURE__ */jsx(MicrositeProductPageContext.Provider, {
    value: {
      showBuyButton
    },
    children
  });
};
function useMicrositeProductPage() {
  return useContext(MicrositeProductPageContext);
}
export { MicrositeProductPageContext, MicrositeProductPageContextProvider, useMicrositeProductPage };
//# sourceMappingURL=MicrositeProductPageContext.mjs.map
